import styled from "styled-components";

export const UserStatusCongratulationsButtonsStyled = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 32px;
    width: 100%;
    max-width: 350px;
    
    button:not(:first-child) {
        margin-top: 12px;
    }
`;
